export default "__VITE_ASSET__a17af10f__"